import { z } from 'zod'

export const schema = z.object({
  title: z.string(),
  description: z.string(),
  image: z.string(),
  name: z.string(),
})

export type schemaType = z.infer<typeof schema>
